export const migrateToV5 = (state)=>{
    return state;
};

//# sourceMappingURL=v5.js.map